document.addEventListener('DOMContentLoaded', function () {




document.addEventListener('click', function (event) {
  var btn = event.target.closest('a.view-details-btn.go-prd');
  if (!btn) return;

  event.preventDefault();

  var card = btn.closest('.product-card');
  if (!card) return;

  var link = card.querySelector('.product-card__link');
  if (!link) return;

  var href = link.getAttribute('href');
  if (!href) return;

  btn.style.pointerEvents = 'none';
  window.location.href = href;
});




  var galleryGrid = document.querySelector('.media-gallery__grid');
  if (!galleryGrid) return;

  var lastColor = null;
  var debounceTimer = null;
  var DEBOUNCE_MS = 150;

  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }

function filterGalleryByColor(colorValue) {
  if (!colorValue) return;
  lastColor = colorValue;
  var target = normalize(colorValue);
  var galleryItems = galleryGrid.querySelectorAll('[ref="media[]"]');
  var matchedItems = [];

  galleryItems.forEach(function (item) {
    var img = item.querySelector('img');
    var imgAlt = img ? normalize(img.getAttribute('alt')) : '';

    if (imgAlt === target) {
      item.classList.add('active');
      item.style.display = '';
      matchedItems.push(item);
    } else {
      item.classList.remove('active');
      item.style.display = 'none';
    }
  });

  if (matchedItems.length === 0) {
    galleryItems.forEach(function (item) {
      item.style.display = '';
    });
    return;
  }

  // Batch-move all matches to the front in one operation, in their
  // original relative order, and pause the observer so this move
  // doesn't trigger another filter pass.
  observer.disconnect();

  var fragment = document.createDocumentFragment();
  matchedItems.forEach(function (item) {
    fragment.appendChild(item);
  });
  galleryGrid.prepend(fragment);

  observer.observe(stableRoot, { childList: true, subtree: true, attributes: true });
}

  function reapplyLastFilter() {
    if (lastColor) filterGalleryByColor(lastColor);
  }

  // Watch the whole document (or a stable ancestor like <main>) since
  // the gallery grid itself may get replaced by morph(), not just mutated
  var stableRoot = document.querySelector('main') || document.body;

  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reapplyLastFilter, DEBOUNCE_MS);
  });

  observer.observe(stableRoot, { childList: true, subtree: true, attributes: true });

  // Set the intended color the moment the swatch is clicked, so lastColor
  // is correct even before the fetch/morph finishes
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.tagName !== 'INPUT') return;
    if (input.getAttribute('data-option-name') !== 'Color') return;
    filterGalleryByColor(input.value);
  });

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.variant-option__button-label');
    if (!label) return;
    var input = label.querySelector('input[data-option-name="Color"]');
    if (input) filterGalleryByColor(input.value);
  });

  // Apply on load
  var checkedInput = document.querySelector('input[data-option-name="Color"]:checked');
  if (checkedInput) filterGalleryByColor(checkedInput.value);
});







// single add to cart
$('body').on('click', 'span.fbtx-link', function () {

    var singlevarID = parseInt($(this).parents('.fbtx-product').attr('data-id'));

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            id: singlevarID,
            quantity: 1
        },
        success: function () {

            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {

                    // Update cart bubble count
                    
if (cart.item_count > 0) {
    
            $('header .cart-bubble[ref="cartBubble"]').removeClass('visually-hidden');
       $('span.cart-bubble__text-count').removeClass('hidden');
       $('dialog.cart-drawer__dialog').removeClass('cart-drawer--empty');
      
        } else {
            $('header .cart-bubble[ref="cartBubble"]').addClass('visually-hidden');
       $('span.cart-bubble__text-count').addClass('hidden');
        $('dialog.cart-drawer__dialog').addClass('cart-drawer--empty');
        }
                    // Refresh cart drawer HTML
                    fetch(window.location.href)
                        .then(res => res.text())
                        .then(html => {

                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');

                            const newCart = doc.querySelector('cart-items-component');
                            const oldCart = document.querySelector('cart-items-component');
                            if (newCart && oldCart) {
                                oldCart.replaceWith(newCart);
                            }

                            
                             //document.querySelector('[data-testid="cart-drawer-trigger"]').click();
                        });
$('[ref="cartBubbleCount"]').text(cart.item_count);
                    $('[ref="cartItemCount"]').text(cart.item_count);
                });
setTimeout(function () {
    document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
}, 100);
        },
        error: function (xhr) {
            console.log(xhr.responseText);
        }
    });

});

// bundle add to cart
$('body').on('click', '.fbtx-wrapper button.fbtx-button', function () {
  var json_obj = [];
    $('.fbtx-products .fbtx-product').each(function () {
        var variantID = $(this).attr('data-id');
        console.log(variantID);
          var item = {};
      item["id"] = variantID;
      item["quantity"] = 1;
      json_obj.push(item);
    });
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: json_obj,
    },
    dataType: "json",
  success: function () {

            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {

                    // Update cart bubble count
                    $('[ref="cartBubbleCount"]').text(cart.item_count);
                    $('[ref="cartItemCount"]').text(cart.item_count);
   if (cart.item_count > 0) {
    
            $('header .cart-bubble[ref="cartBubble"]').removeClass('visually-hidden');
       $('span.cart-bubble__text-count').removeClass('hidden');
       $('dialog.cart-drawer__dialog').removeClass('cart-drawer--empty');
      
        } else {
            $('header .cart-bubble[ref="cartBubble"]').addClass('visually-hidden');
       $('span.cart-bubble__text-count').addClass('hidden');
        $('dialog.cart-drawer__dialog').addClass('cart-drawer--empty');
        }
                    // Refresh cart drawer HTML
                    fetch(window.location.href)
                        .then(res => res.text())
                        .then(html => {

                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');

                            const newCart = doc.querySelector('cart-items-component');
                            const oldCart = document.querySelector('cart-items-component');

                            if (newCart && oldCart) {
                                oldCart.replaceWith(newCart);
                            }

                            
                            // document.querySelector('[data-testid="cart-drawer-trigger"]').click();
                        });

                });

                setTimeout(function () {
    document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
}, 100);
        },
  });
});




// bundle section hotspot
$(document).ready(function () {

    $('.bundle-wrapper').each(function () {
        var $bundle = $(this);

        function activateBundleHotspot(id) {
            $bundle.find('.fbtx-product').css('opacity', 1).removeClass('is-active');
            $bundle.find('.fbtx-hotspot').removeClass('is-active');
            $bundle.find('.fbtx-hotspot .fbtx-popup').hide();

            $bundle.find('.fbtx-product[data-id="' + id + '"]').css('opacity', 1).addClass('is-active');
            $bundle.find('.fbtx-hotspot[data-id="' + id + '"]').addClass('is-active').find('.fbtx-popup').show();
        }

        var $firstProduct = $bundle.find('.fbtx-products .fbtx-product').first();

        $bundle.find('.fbtx-product').css('opacity', 1);
        $bundle.find('.fbtx-hotspot .fbtx-popup').hide();

        if ($firstProduct.length) {
            activateBundleHotspot($firstProduct.data('id'));
        }

        $bundle.find('.fbtx-product').hover(
            function () {
                activateBundleHotspot($(this).data('id'));
            },
            function () {
                if ($firstProduct.length) {
                    activateBundleHotspot($firstProduct.data('id'));
                }
            }
        );
    });

});




// $('body').on('click','cart-icon.header-actions__cart-icon',function () {
//     setTimeout(function () {
//     alert(33)
//     applyCartStyles();
// }, 200);
// })



function applyCartStyles() {
$('.cart-actions').css({
    display: "flex",
    flexDirection: "column",
    gap: "0",
    borderTop: "1px solid var(--color-border)",
    borderBottom: "1px solid var(--color-border)",
    paddingTop: "0",
    paddingBottom: "0",
    marginTop: "var(--margin-3xs)"
});
$('.cart-totals__container').css({
    display: "flex",
    flexDirection: "column",
});
$('.cart-totals__icon').css({
    height: "var(--icon-size-xs)",
    width: "var(--icon-size-xs)",
    margin: "0"
});
$('span.cart-totals__item.cart-totals__total').css('padding-top', '20px');
  $(".cart-totals").css("width", "100%");

  $("summary.cart-discount__summary").css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  });

  $("form.cart-discount__form").css({
    display: "flex",
    gap: "var(--padding-md)",
    alignItems: "center",
    height: "100%",
    paddingBlock: "var(--padding-2xs) var(--padding-sm)"
  });

  $(".cart-discount__input").css({
    backgroundColor: "var(--color-input-background)",
    color: "var(--color-input-text)",
    borderWidth: "var(--style-border-width-inputs)",
    borderColor: "var(--color-input-border)",
    borderStyle: "solid",
    borderRadius: "var(--style-border-radius-inputs)",
    padding: "var(--padding-sm) var(--padding-md)",
    height: "100%",
    flexGrow: "1",
    minWidth: "0",
    fontSize: "var(--font-size--sm)"
  });

  $(".cart__ctas .cart__checkout-button").css({
    width: "100%",
    height: "clamp(25px,var(--height-buy-buttons),55px)",
    paddingInline: "var(--padding-4xl)"
  });

  $(".cart-totals__item").css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  });

}

// Initial call
applyCartStyles();

// Watch for DOM changes
const observer = new MutationObserver(function () {
    applyCartStyles();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});





